"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ticket = Ticket;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cssModifierUtilities = require("../utilities/cssModifierUtilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-next-line complexity
function getTicketModifiers(isDisabled, status) {
  var modifiers = [];

  if (isDisabled) {
    modifiers.push('disabled');
  }

  if (status) {
    modifiers.push('status');

    switch (status.toLowerCase()) {
      case 'warning':
        modifiers.push('status-warning');
        break;

      case 'error':
        modifiers.push('status-error');
        break;

      default:
    }
  }

  return modifiers;
}

function Ticket(_ref) {
  var children = _ref.children,
      isDisabled = _ref.isDisabled,
      status = _ref.status;
  var ticketClass = (0, _cssModifierUtilities.buildClassName)('ticket', getTicketModifiers(isDisabled, status));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: ticketClass
  }, children);
}

Ticket.propTypes = {
  children: _propTypes["default"].node.isRequired,
  isDisabled: _propTypes["default"].bool,
  status: _propTypes["default"].string
};
Ticket.defaultProps = {
  isDisabled: false
};